export const Hero = ({
  eyebrow,
  title,
  desc,
  height,
  logoWidth,
  actions,
  centered = false,
}) => {
  return (
    <div className={`App-hero relative overflow-hidden ${height}`}>
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.06]"
        style={{
          backgroundImage:
            "radial-gradient(circle, currentColor 1px, transparent 1px)",
          backgroundSize: "20px 20px",
        }}
      />
      <div className="container relative h-full">
        <div
          className={`mx-auto h-full py-12 px-4 sm:px-6 lg:py-16 lg:px-16 flex flex-col gap-10 ${
            centered
              ? "max-w-2xl items-center text-center justify-center"
              : "max-w-full sm:flex-row sm:items-center sm:justify-between"
          }`}
        >
          <div
            className={centered || !logoWidth ? "w-full" : "sm:w-1/2 w-full"}
          >
            {logoWidth && centered && (
              <img
                src="/banner.png"
                className={`${logoWidth} mx-auto mb-6`}
                alt="Go Markets logo"
                width={480}
                height={480}
                loading="eager"
                decoding="async"
              />
            )}

            {eyebrow && (
              <span className="inline-flex items-center mb-3 px-3 py-1 rounded-full bg-dark/10 text-xs font-semibold uppercase tracking-widest text-secondary">
                {eyebrow}
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="h-8 w-8 object-cover rounded-full ml-2"
                >
                  <source src="./bloub-my-cycle.mp4" type="video/mp4" />
                </video>
              </span>
            )}
            <h1 className="mb-4 text-3xl font-bold tracking-tight text-secondary sm:text-5xl font-display leading-[1.1]">
              {title}
            </h1>
            <p
              className={`text-base sm:text-lg leading-relaxed text-slate-600 ${
                centered ? "max-w-xl mx-auto" : "max-w-md"
              }`}
            >
              {desc}
            </p>

            {actions && (
              <div
                className={`mt-8 flex flex-wrap gap-3 ${
                  centered ? "justify-center" : ""
                }`}
              >
                {actions}
              </div>
            )}
          </div>

          {logoWidth && !centered && (
            <div className="flex justify-center sm:justify-end sm:w-1/2 w-full lg:flex-shrink-0">
              <img
                src="/banner.png"
                className={logoWidth}
                alt="Go Markets logo"
                width={480}
                height={480}
                loading="eager"
                decoding="async"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
